import React, { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'reactstrap';
import { Loader } from './Loader';
import { handleResponse } from '../helpers/HandleResponse';
import logoDark from "../../assets/images/logo-dark.png";
import html2canvas from 'html2canvas';
import moment from 'moment';


// MACL's own GST registration number, printed on every tax invoice.
const MACL_GST_TIN = "1000133GST501";

export const TransactionModal = ({visible, toggle, getRequest=()=>false, triggerRequest=()=>false, parentID=null, size="lg"}) => {

    const [modalLoading, setModalLoading] = useState(false)
    const [data, setData] = useState({})
    const [fontSize, setFontSize] = useState(16);

    useEffect(() => {
        const getData = async () => {
            setModalLoading(true)
            const response = await getRequest({id: parentID})
            if(response && response.data){
                setData(response.data)
            }
            setModalLoading(false)
        }
        if(visible && parentID){
            getData();
        } else {
            setData({})
        }
        return () => {
            setData({})
        }
    }, [visible, parentID, getRequest])

    
    const downloadReceipt = (fileName) => {
        const divToCapture = document.getElementById('receipt-container');
            html2canvas(divToCapture).then(canvas => {
            const dataUrl = canvas.toDataURL("image/png");
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = fileName+'.png';
            link.click();
        });
    };

    
    const payFn = async(id) => {
        setModalLoading(true)
        const response = await triggerRequest({id: id})
        if(response){
            if(response?.Status === "error"){
                handleResponse(response)
                setModalLoading(false)
            } else if(response?.Status === "verified"){
                window.location.href = "/paymentSuccess"
            } else {
                if(response.Data?.gateway_url){
                window.location.replace(response.Data.gateway_url)
                } else {
                setModalLoading(false)
                }
            }
        } else {
            setModalLoading(false)
        }
    }

    useEffect(() => {
        const handleResize = () => {
            const windowWidth = window.innerWidth;
            const calculatedFontSize = windowWidth < 576 ? 10 : 14;
            setFontSize(calculatedFontSize);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const isTaxInvoice = parseFloat(data?.tax_amount) > 0;

    return (
        <Modal size={size} isOpen={visible} toggle={()=>toggle({})} keyboard={false} backdrop="static">
            <Loader loading={modalLoading} message="Please don't go back or refresh page!" />
            <div className="modal-header">
            <h5 className="modal-title mt-0" id="myModalLabel">Receipt</h5>
            <button type="button" onClick={() => toggle({})} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div id="modalBody" className="modal-body">
            {data ? (
                <React.Fragment>
                <div id='receipt-container' style={{padding:'20px', }}>
                    <Row>
                        <Col>
                            <div style={{display:'flex',justifyContent:'end',height:'40px'}}>
                                <img src={logoDark} height="40px" alt=""/>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {/* Only a taxed receipt is a tax invoice. Permit
                                receipts are untaxed — GST is charged once, when
                                money enters the wallet — so this same modal must
                                not label those as tax invoices. */}
                            <div style={{paddingTop:'20px', display:'flex',justifyContent:'center'}}>
                                <h3>{isTaxInvoice ? "Payment Receipt / Tax Invoice" : "Payment Receipt"}</h3>
                            </div>
                            {isTaxInvoice ? (
                                <div style={{paddingBottom:'20px', display:'flex',justifyContent:'center'}}>
                                    <span><b>MACL GST TIN No: </b>{MACL_GST_TIN}</span>
                                </div>
                            ) : <div style={{paddingBottom:'20px'}}></div>}
                        </Col>
                    </Row>
                    <Row>
                    {data.company_name ? (
                        <Col md="12">
                            <span><b>Company Name: </b>{data.company_name}</span>
                        </Col>
                    ) : null}
                    {data.company_tin ? (
                        <Col md="12">
                            <span><b>Company TIN No: </b>{data.company_tin}</span>
                        </Col>
                    ) : null}
                    <Col md="12">
                        <span><b>Date: </b>{moment(data.date)?.format("Do MMMM YYYY")}</span>
                    </Col>
                    <Col md="12">
                        <span><b>Transaction No: </b>{data.transaction_number}</span>
                    </Col>
                    {/* Present only on a direct permit purchase; ordinary
                        wallet top-ups have no vessel. */}
                    {data.vessel_label ? (
                        <Col md="12">
                            <span><b>Vessel: </b>{data.vessel_label}</span>
                        </Col>
                    ) : null}
                    </Row>
                    <br/>
                    <div style={{ fontSize: fontSize }}>
                    <Row>
                        <Col md="12"><div style={{borderTop:'1px solid #bdbdbd', paddingBottom:'5px'}}></div></Col>
                    </Row>
                    <Row>
                        <Col md="6" xs='4'><b>Item Name</b></Col>
                        <Col md="2" xs='3'><b>Price</b></Col>
                        <Col md="2" xs='2' className='text-center'><b>Qty</b></Col>
                        <Col md="2" xs='3'><b>Total</b></Col>
                    </Row>
                    <Row>
                        <Col md="12"><div style={{borderBottom:'1px solid #bdbdbd', paddingBottom:'5px'}}></div></Col>
                    </Row>

                    {data.transaction_details ? data.transaction_details.map((item,index)=>
                        <Row key={index}>
                        <Col md="6" xs='4' style={{paddingTop:'5px'}}>
                            {item.item_name}
                            {/* Permit lines carry their validity window here — the
                                item name says "24 Hour" but never which 24 hours. */}
                            {item.description ? (
                                <div style={{fontSize:'0.85em', color:'#74788d', paddingTop:'2px'}}>{item.description}</div>
                            ) : null}
                        </Col>
                        <Col md="2" xs='3' style={{paddingTop:'5px'}}>{item.unit_price}</Col>
                        <Col md="2" xs='2' style={{paddingTop:'5px', textAlign:'center'}}>{item.quantity}</Col>
                        <Col md="2" xs='3' style={{paddingTop:'5px'}}>{item.total}</Col>
                        </Row>
                    ) : null}
                    
                    <Row>
                        <Col md="12"><div style={{borderBottom:'1px solid #bdbdbd', paddingBottom:'5px'}}></div></Col>
                    </Row>
                    </div>
                    {/* Only top-ups carry tax; in-portal spending is untaxed, so
                        show a single total rather than an identical subtotal and
                        total with a zero tax line between them. */}
                    <Row style={{paddingTop:'10px'}}>
                        {isTaxInvoice ? (
                            <>
                                <Col md="12">
                                    <span><b>Subtotal:</b> {data.subtotal}</span>
                                </Col>
                                <Col md="12">
                                    <span><b>GST:</b> {data.tax_amount}</span>
                                </Col>
                            </>
                        ) : null}
                        <Col md="12">
                            <span><b>Total:</b> {data.net_amount}</span>
                        </Col>
                    </Row>

                    <br/>
                    <div align="center"><b>{data?.status !== "COMPLETED" ? "- PAYMENT PENDING -" : "- PAID -"}</b></div>
                    <Row>
                        <Col>
                            <div style={{paddingTop:'20px',paddingBottom:'20px', display:'flex',justifyContent:'center'}}>
                            <b>This is a system generated receipt.</b>
                            </div>
                        </Col>
                    </Row>
                </div>
                
                </React.Fragment>
            ) : null}
            </div>
            <div className="modal-footer">
            <button type="button" onClick={() => toggle({})} className="btn btn-secondary waves-effect" data-dismiss="modal">Close</button>
            <button type="button" onClick={()=>downloadReceipt(data.transaction_number)} className="btn btn-primary waves-effect">Download</button>
            {data?.status !== "COMPLETED" && <button type="button" onClick={() => payFn(data.id)} className="btn btn-info waves-effect">Pay Now</button>}
            </div>
        </Modal>
    )

}